import { useQuery } from "@tanstack/react-query";

import { getStatistics } from "../services/viewingMotionsServices";
import { useTranslation } from "react-i18next";
import { FIVE_MINUTES_IN_MS } from "../configuration/globalConstants";
import { useSessionStore } from "../store/sessionStore";

export function useStatistics() {
  const [t] = useTranslation("global");
  const { myStore } = useSessionStore();

  const statistics = useQuery({
    queryKey: ["statistics", myStore.id],
    queryFn: () => getStatistics(),
    staleTime: FIVE_MINUTES_IN_MS,
  });
  const setTitle = (level) => {
    if (level === 0) {
      return t("dashboard.completeArea");
    } else if (level === 1) {
      return t("dashboard.sectionArea");
    } else {
      return t("dashboard.subSectionArea");
    }
  };
  const parseStatistics = (data) => {
    return data.map((level) => ({
      made: level.accumulationMovements,
      total: level.movementGoal,
      title: setTitle(level.level),
    }));
  };

  return {
    statistics: statistics.data ? parseStatistics(statistics.data) : null,
  };
}
